import { ChangeEvent } from 'react'

const zipCodeFormater = (input: HTMLInputElement) => {
  if (!/\D/.test(input.value)) {
    const value = input.value.replace(/\D/, '').replace('-', '')
    if (value.length === 8) {
      input.value = `${value.slice(0, 5)}-${value.slice(5, 8)}`
    }
  }
}

export const zipCodeMask = (event: ChangeEvent<HTMLInputElement>) => {
  if (event.target instanceof HTMLInputElement) {
    zipCodeFormater(event.target)
  }
}
